var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCarouselMarqe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 51,
    viewBox: "0 0 150 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1943_704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9998 38.0033L62.9487 43.9521L92.9527 13.9482L87.0038 7.99931L56.9998 38.0033Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5391 43.9512H92.9521V13.9102H84.5391V43.9512Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 7.99911V16.4121H78.555V7.99911H57Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1943_704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.952,
    height: 35.952,
    fill: "white",
    transform: "matrix(0 -1 1 0 57 43.9521)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCarouselMarqe);
export default __webpack_public_path__ + "static/media/arrow-carousel-marqe.f6e0cfe11cd475a87606de98dbf92578.svg";
export { ForwardRef as ReactComponent };